import React from "react";
import GoldRateTable from "../tables/GoldRateTable";
import TopStoryCard from "../top-story-card/TopStoryCard";
import { formatTableDate, getLastPublishedTimeGoldForex } from "../../../atoms/Chart";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { DfpComponent } from "../../../ads/dfp-component";
import GCCHistoricalRates from "../historical-pages/gold-rate-page/GCCHistoricalRates";
import GoldRateLinks from "./GoldRateLinks";
import GoldUpdateArticle from "./GoldUpdateArticle";
import "./middle-section.m.css";

const GCCGoldRates = ({ apiData, country, currency }) => {
  const currentDate = formatTableDate();
  const centerTopAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "gold_forex_center_top_ad"], {})
  );
  return (
    <div styleName="forex-page-middle-section-wrapper">
      <div>
        <div id="live-gold-rates" styleName="first-section">
          <TopStoryCard
            id="forex-page-second-section-ad"
            heading={`${country} Gold Rates (${currency}/g)`}
            live="LIVE"
            date={currentDate}
            updatedAt={getLastPublishedTimeGoldForex(apiData?.allApiData?.goldApiData?.lastUpdated)}
          />
          <GoldRateTable goldApidata={apiData?.allApiData?.goldApiData} country={country} />
          <div styleName="bottom-section-details-wrapper">
            <Link href="#historical-gold-rates">
              <span>Click here to view past 30 days rate</span>
            </Link>
            <span style={{ color: "#596E79", fontSize: "12px" }}>PROVIDED BY</span>
            <a
              href="https://www.instagram.com/joyalukkas"
              rel="noopener noreferrer nofollow"
              style={{ display: "inline-block", maxWidth: "100px" }}
              target="_blank"
            >
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 60">
                <g>
                  <path
                    fill="#a71833"
                    d="M41.44,36.76l.03.46c.08,3.12.13,6.32.13,9.49,0,2.01-.02,4.05-.06,6.04v.43s3,0,3,0c0,0,0-.39,0-.42-.08-3.23-.18-6.98-.18-10.63,0-1.78.02-3.38.06-4.92,0-.02.04-.44.04-.44h-3.01"
                  />
                  <path
                    fill="#a71833"
                    d="M45.25,40.76s.04.28.04.42c0,.09.04,1.79.04,2.74,0,.72,0,1.45,0,2.15-.01.63-.01,1.23-.01,1.75,0,.55,0,1.04.02,1.42.17,3.45,2.82,4.17,5,4.17,1.74,0,3.14-.55,4.02-1.5,0,.25-.01,1.26-.01,1.26h2.78s-.02-.47-.02-.47c-.17-3.9-.03-11.29-.01-11.5.01-.2.03-.46.03-.46h-2.96s.02.32.03.44c0,.13,0,0,0,0l.03,1.06c.05,1.78.11,4,0,5.42-.18,2.2-1.34,3.32-3.42,3.32-1.63,0-2.57-.83-2.65-2.37-.03-.66-.04-1.38-.04-2.18l.06-2.56s.06-2.52.08-2.7c0-.17.03-.43.03-.43h-3.02"
                  />
                  <path
                    fill="#a71833"
                    d="M68.17,40.79l-.44.44c-3.43,3.76-4.34,4.76-4.67,5.1,4.96,5.63,5.93,6.83,5.93,6.83h-3.39l-.12-.15c-1.04-1.37-2.19-2.7-3.31-3.98,0,0-1.25-1.48-1.46-1.72.01.36.15,5.87.15,5.87h-2.93v-.23c.05-.22.06-4.45.06-4.45,0-4.17-.24-11.15-.24-11.27-.01-.4-.03-.47-.03-.47h3.01s-.04.33-.04.42c0,.18-.03,5.63-.03,5.63,0,0,.04,2.27.04,2.59.55-.64.51-.68.78-.94l.17-.2c.95-1.07,1.94-2.17,2.81-3.32.04-.06.13-.16.13-.16h3.57"
                  />
                  <path
                    fill="#a71833"
                    d="M79.87,40.79l-.44.44c-3.43,3.76-4.33,4.76-4.67,5.1,4.96,5.63,5.93,6.83,5.93,6.83h-3.4l-.11-.15c-1.04-1.37-2.19-2.7-3.31-3.98,0,0-1.25-1.48-1.46-1.72,0,.36.15,5.87.15,5.87h-2.93v-.23c.04-.22.06-4.45.06-4.45,0-4.17-.23-11.15-.24-11.27-.02-.4-.03-.47-.03-.47h3.01s-.04.33-.04.42c0,.18-.03,5.63-.03,5.63,0,0,.04,2.27.04,2.59.56-.64.5-.68.77-.94l.19-.2c.95-1.07,1.94-2.17,2.81-3.32.05-.06.13-.16.13-.16h3.58"
                  />
                  <path
                    fill="#a71833"
                    d="M31.05,41.1c-.14.03-.32.09-.32.09l-.23,2.54s.42-.19.73-.31c.32-.12,2.2-.88,3.98-.87.85.02,2.28.16,2.33,1.25.03.51-.27.85-.97,1.13-.33.13-.74.25-1.27.37l-1.09.23-.43.09c-2.2.48-4.53,1.24-4.4,4.01.15,2.9,2.7,3.54,4.81,3.55l6.32-.02s-.09-4.02-.09-5.58v-.04c0-1.47,0-2.87-.04-3.67-.07-1.58-.71-3.39-4.99-3.39-1.4,0-3.17.3-4.35.62M32.11,49.48c0-.96.91-1.4,2.3-1.76l.91-.21,1.26-.31c.48-.14.87-.32,1.08-.43v2.64c0,.15,0,.52,0,1.57-.13,0-3.17-.02-3.17-.02-.69,0-2.3-.13-2.37-1.39v-.08"
                  />
                  <path
                    fill="#a71833"
                    d="M81.3,41.11l-.28.07s-.04.42-.21,2.13l-.04.5s.25-.15.38-.21c.16-.08,1.97-1.02,4.34-1.04.85,0,2.29.16,2.34,1.25v.08c0,.46-.3.79-.97,1.06-.33.13-.73.24-1.27.37l-1.12.24-.41.09c-2.12.47-4.39,1.18-4.39,3.78v.21c.14,2.88,2.66,3.52,4.74,3.54h6.18s.2.01.2.01v-.45c-.07-1.42-.07-3.4-.07-5.16v-.04c0-1.33.01-2.83-.03-3.65-.08-1.58-.72-3.39-5-3.39-1.4,0-2.83.2-4.38.62M82.4,49.5c0-.95.92-1.39,2.3-1.74l.92-.22,1.26-.31c.44-.15.81-.3,1.12-.45,0,.09-.04,4.1-.05,4.23-.13,0-3.23-.02-3.23-.02-.83,0-2.25-.18-2.32-1.38v-.09"
                  />
                  <path
                    fill="#a71833"
                    d="M94.92,43.63c-.06.35.2.77.66,1.22.23.23.51.45.76.65l.91.68c1.34.99,2.67,2.1,2.75,3.72.04.82-.2,1.52-.72,2.07-1.01,1.06-2.72,1.22-3.65,1.22h-.4s-1.3,0-1.3,0c-1.97-.02-2.42,0-2.42,0v-2.22s4.23,0,4.23,0c.56,0,.96-.12,1.2-.38.21-.22.23-.5.23-.61,0,0,0-.04,0-.04,0-.36-.23-.73-.68-1.18-.21-.2-.47-.41-.77-.63l-.61-.46-.3-.22c-1.4-1.02-2.66-2.06-2.73-3.6v-.19c-.01-.78.25-1.47.75-1.99.72-.76,1.92-1.16,3.48-1.16.98,0,1.97.15,2.91.31.1.02.3.07.3.07l.23,2.58s-4.52-1.67-4.8.17"
                  />
                  <path
                    fill="#a71833"
                    d="M3.25,36.69v.45c.13,4.62.12,10.72.11,12.04-.02,1.01-.42,1.42-1.39,1.42-.4,0-1.2-.07-1.57-.18-.35-.1-.39-.13-.39-.13v2.79s1.06.25,2.27.27c1.21.09,2.17-.21,2.88-.9,1.23-1.21,1.13-3.21,1.13-3.23,0-.06-.23-6.89-.11-12.07v-.22s.02-.22.02-.22h-2.78s-.19,0-.19,0"
                  />
                  <path
                    fill="#a71833"
                    d="M8.66,42.2c-1.04,1.16-1.57,2.7-1.57,4.55s.52,3.42,1.56,4.58c1.07,1.2,2.55,1.8,4.4,1.8s3.32-.6,4.4-1.8c1.03-1.15,1.56-2.69,1.56-4.58s-.53-3.38-1.56-4.55c-1.09-1.21-2.57-1.83-4.4-1.83s-3.31.62-4.39,1.83M9.76,46.75c0-1.13.27-2.04.83-2.79.59-.78,1.42-1.17,2.46-1.17s1.87.39,2.45,1.17c.55.74.83,1.68.83,2.79s-.26,2.04-.81,2.78c-.58.79-1.41,1.19-2.48,1.19s-1.9-.4-2.49-1.19c-.53-.74-.8-1.65-.8-2.78"
                  />
                  <path
                    fill="#a71833"
                    d="M17.11,40.42l.41.56c1.72,2.23,3.29,4.45,4.8,6.82-.02.36-.03,1.44-.06,4.91,0,.03-.01.4-.01.4h3l-.02-.81s-.09-4.46-.09-4.5c1.71-2.6,4.94-6.77,5.08-6.94l.31-.43h-3.53s-2.65,3.77-3.27,4.65c-.1-.16-1.89-2.86-1.89-2.86l-1.16-1.79h-3.56"
                  />
                </g>
                <g>
                  <path
                    fill="#dfad00"
                    d="M55.41,6.58c-.09,0-.23.02-.39.04h-.03s-.06.02-.1.02c-.32.05-.67.13-1.03.25-.45.15-.91.35-1.37.59-.12.06-.23.13-.35.2-1.05.61-2.08,1.45-3.05,2.5-1.14,1.23-2.16,2.7-3.06,4.37-.15.29-.31.6-.46.92-.42.87-.78,1.76-1.08,2.62-.08.22-.15.44-.22.67.31.63,1.3,2.63,2,3.86.11-.53.24-1.08.4-1.63.43-1.52,1.03-3.06,1.78-4.56,1.14-2.3,2.56-4.36,4.1-5.95,1.39-1.43,2.82-2.43,4.15-2.88,0,0,.02,0,.03,0-.48-.81-1.29-1-1.32-1.01"
                  />
                  <path
                    fill="#cfcfcf"
                    d="M53.96,14.8c-.52-.98-1.12-1.94-1.74-2.79-.39.41-1.07,1.23-1.82,2.55.37.62.8,1.39,1.15,2.11.74,1.5,1.34,3.03,1.77,4.56.12.43.23.87.33,1.3.8-1.17,1.57-2.76,2-3.73-.05-.15-.1-.31-.15-.47-.3-.86-.66-1.75-1.08-2.62-.15-.32-.31-.63-.46-.91"
                  />
                  <path
                    fill="#cfcfcf"
                    d="M53.16,30.67c.29-.15.54-.3.77-.46.12-.08.23-.17.36-.27-.46.1-.85.09-1.16.04h-.04c-.58-.12-1.2-.34-1.82-.68-1.61-.88-3.26-2.49-4.79-4.67-.56-.79-1.09-1.65-1.59-2.56-.25-.46-.5-.94-.72-1.41-.3-.62-.58-1.25-.82-1.86-.81-2-1.32-3.88-1.51-5.61-.16-1.41-.11-2.7.15-3.83.11-.54.27-1.03.47-1.46,0-.03.2-.48.57-.9-.05.01-.11.03-.16.04-.29.08-.59.19-.89.31-.44.19-.83.39-1.19.62-.35.22-.66.47-.93.72-.19.18-.36.39-.53.6-.31.42-.58.91-.79,1.46-.13.34-.25.7-.34,1.09-.12.51-.21,1.06-.25,1.64-.09,1.16-.01,2.41.23,3.72.23,1.25.61,2.55,1.12,3.84.21.53.44,1.06.7,1.61.11.23.22.46.34.68.32.63.68,1.24,1.05,1.82.93,1.45,1.97,2.7,3.09,3.71.65.59,1.33,1.09,2.01,1.5.28.17.55.31.83.44.36.17.71.31,1.06.42.56.17,1.11.27,1.63.3.28.01.56,0,.81-.03.36-.05.73-.14,1.12-.28.38-.13.77-.31,1.23-.54"
                  />
                  <path
                    fill="#cfcfcf"
                    d="M49.3,8.92c-.48-.38-.95-.71-1.45-1-.12-.07-.23-.13-.35-.19-.45-.24-.91-.44-1.37-.59-.36-.12-.72-.2-1.07-.25l-.26-.04c-.06,0-.12,0-.2-.01-.16.03-.82.2-1.29,1.01,1.32.45,2.75,1.44,4.13,2.87.04.05.08.09.12.13.39-.5,1.1-1.33,1.74-1.93"
                  />
                  <path
                    fill="#dfad00"
                    d="M59.65,23.07c.12-.22.23-.45.34-.68.26-.54.49-1.07.7-1.61.52-1.3.9-2.59,1.13-3.84.24-1.31.32-2.56.23-3.73-.04-.58-.13-1.13-.25-1.64-.09-.38-.2-.74-.33-1.09-.21-.54-.48-1.03-.79-1.46-.17-.23-.35-.43-.53-.6-.27-.26-.58-.51-.93-.73-.35-.23-.74-.43-1.19-.62-.3-.12-.6-.23-.89-.31-.04,0-.09-.02-.13-.03.37.43.53.88.54.91.19.4.35.89.46,1.45.26,1.12.31,2.41.15,3.82-.19,1.73-.7,3.62-1.51,5.61-.24.61-.52,1.23-.82,1.86-.23.48-.48.96-.72,1.41-.5.91-1.03,1.77-1.59,2.56-.96,1.36-1.96,2.5-2.99,3.39.45.36,1.4,1.05,2.19,1.28,1.02.29,2.51-.18,3.44-1.06l.05-.05c.87-.89,1.67-1.91,2.4-3.05.37-.58.72-1.2,1.05-1.82"
                  />
                </g>
              </svg>
            </a>
          </div>
          <div styleName="horizonal-separator" style={{ margin: "10px 0" }}></div>
          <GoldRateLinks />
          <GoldUpdateArticle />
        </div>
        {country === "India" && (
          <div styleName="gold-forex-page-text-wrapper">
            <h3>Gold allowance for Indian residents traveling from UAE</h3>
            <p>
              If you are buying gold in the UAE and planning to take it to India, there are clear customs rules to
              follow. Indian residents are allowed to bring a small quantity of jewellery duty-free: men can carry up to
              20 grams, valued at around INR50,000, while women can carry up to 40 grams worth about INR100,000. The
              duty-free allowance applies only to jewellery — gold coins and bars are not included and will always
              attract customs duty. Anything above the duty-free limit is subject to additional customs charges.
              Typically, the duty starts at about 3% for 20–50 grams, rises to 6% for 50–100 grams, and can go up to 10%
              for larger quantities.
            </p>
            <h3>Customs duty on gold when staying abroad over 6 months</h3>
            <p>
              For those who have stayed abroad for more than six months, there is a concessional duty of around 13.7% on
              up to 1 kilogram of gold, including jewellery, coins, or bars. It’s important to note that this 1 kg limit
              encompasses both duty-free and dutiable portions. For example, if a male passenger is allowed a duty-free
              allowance of 20 grams of gold jewellery worth up to INR50,000, the remaining 980 grams would be subject to
              customs duty.
            </p>
            <h3>Declaring gold purchases at customs</h3>
            <p>
              To avoid fines or confiscation, travellers should always declare gold beyond the duty-free allowance,
              carry purchase invoices, and be prepared for customs checks on arrival. Compliance with these rules
              ensures a smooth process when bringing gold from the UAE into India.
            </p>
          </div>
        )}
        <div styleName="ad-slot-300x250-wrapper">
          <DfpComponent
            adStyleName="ad-slot-size-300x250-constant"
            id={`forex-page-middleSection-top-ad`}
            path={"/1019334/GULFNEWS/Gulfnews_Native/gulfnews_goldforex_native/gulfnews_goldforex_native_1"}
            size={centerTopAdConfig.sizes}
          />
        </div>
        <div id="historical-gold-rates" styleName="second-section">
          <GCCHistoricalRates
            historicalRate={apiData?.allApiData?.historicalGoldApiData}
            country={country}
            currency={currency}
          />
        </div>
      </div>
    </div>
  );
};

export default GCCGoldRates;
